import { Button } from '@trellis/roots/button'
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@trellis/roots/sheet'
import { SlidersHorizontal } from 'lucide-react'
import type { ReactNode } from 'react'
import { useState } from 'react'

interface FilterSheetProps {
  /** Inline controls rendered on desktop (≥ md) */
  toolbar: ReactNode
  /** Stacked controls rendered inside the mobile sheet */
  sheet: ReactNode
  /** Number of active filters — shown as badge on trigger button */
  activeCount?: number
  onClear?: () => void
}

export function FilterSheet({
  toolbar,
  sheet,
  activeCount = 0,
  onClear,
}: FilterSheetProps) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <div className="hidden items-center gap-2.5 md:flex">{toolbar}</div>

      <div className="flex items-center gap-2 md:hidden">
        <Button variant="outline" size="sm" onClick={() => setOpen(true)}>
          <SlidersHorizontal className="size-4" />
          Filters
          {activeCount > 0 && (
            <span className="bg-primary text-primary-foreground ml-1 flex size-4 items-center justify-center rounded-full text-[10px]">
              {activeCount}
            </span>
          )}
        </Button>
        {activeCount > 0 && onClear && (
          <button
            type="button"
            onClick={onClear}
            className="text-muted-foreground text-xs underline underline-offset-2"
          >
            Clear
          </button>
        )}
      </div>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="px-4 pb-8">
          <SheetHeader>
            <SheetTitle>Filters</SheetTitle>
          </SheetHeader>
          <div className="mt-4 flex flex-col gap-4">{sheet}</div>
          {onClear && (
            <Button
              variant="ghost"
              className="mt-6 w-full"
              onClick={() => {
                onClear()
                setOpen(false)
              }}
            >
              Clear all filters
            </Button>
          )}
        </SheetContent>
      </Sheet>
    </>
  )
}
